<template>
  <SideSheet
    class="details-sidebar"
    data-testid="details-sidebar"
    position="right"
    :is-open="isOpen"
    @close="$emit('close')"
  >
    <NavBar sticky>
      <template #left>
        <BackButton icon="EF0030" @click="$emit('close')" />
      </template>
    </NavBar>
    <section class="details-sidebar__content">
      <Heading class="details-sidebar__title" :level="3">
        {{ data.title }}
      </Heading>
      <BaseText class="details-sidebar__description">
        {{ data.description }}
      </BaseText>
      <Row
        v-if="data.button"
        :left-title="data.button.label"
        has-interaction
        @click="onRowClick(data.button.action)"
      >
        <template #icon-right>
          <BaseIcon icon="EA0080" />
        </template>
      </Row>
    </section>
  </SideSheet>
</template>

<script lang="ts" setup>
import { watch } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  Heading,
  BaseText,
  Row,
  BaseIcon
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';

import { IDetails } from '@/modules/transaction/services/product-investment';

import { removeBodyScroll } from '@/modules/common/helpers/browser';

const router = useRouter();

interface EmitEvents {
  (event: 'close'): void;
}
defineEmits<EmitEvents>();

interface Props {
  isOpen: boolean;
  data: IDetails;
}
const props = defineProps<Props>();

function onRowClick(action: string) {
  const routerName: { [key: string]: string } = {
    COSTS: 'costs'
  };

  const url = router.resolve({ name: routerName[action] }).href;

  window.open(url, '_blank');
}

watch(
  () => props.isOpen,
  _isOpen => {
    removeBodyScroll();
  }
);
</script>

<style lang="less" scoped>
.details-sidebar {
  height: 100%;

  :deep(.panel-content.right) {
    max-width: 683px;
    width: 100%;
  }

  .navbar-container {
    border-bottom: none;
  }

  &__content {
    max-width: 571px;
    width: 100%;
    margin: 0 auto;
    padding: @size-spacing-x800 @size-spacing-x500 @size-spacing-x1400;
  }

  &__title {
    margin-bottom: @size-spacing-x600;
  }

  &__description {
    white-space: pre-line;
    margin-bottom: @size-spacing-x600;
  }

  :deep(.row-item > div) {
    padding: @size-spacing-x450 0;
  }
}
</style>
